import React from 'react';
import AiChat from './AiChat';

const ChatView: React.FC = () => {
  return (
    <AiChat
      showSessions
      defaultUseDrift
      defaultUseMcp
      height="72vh"
    />
  );
};

export default ChatView;